import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import JourneyWithNextSchedule from '../../JourneyWithNextSchedule';
import JourneyAction from '../../JourneyAction';
import CircleIcon from '../../CircleIcon';
import { JourneyActionPayload, getCurrentSchedule } from '..';
import { dynamicCustomEventTracking } from '../../../../lib/gtm';
import { Button as ButtonSmall } from '../style';
import { ISchedules } from '../../../../services/journey.service';

export const AwaitingAnamneseSmall = ({ journey }: JourneyActionPayload) => {
  const currentSchedule = getCurrentSchedule(journey);
  const anamneseURL = journey.haveToAnswerAnamnese;
  return (
    <JourneyWithNextSchedule
      journey={journey}
      schedule={currentSchedule as ISchedules}
      actionButton={
        <ButtonSmall
          variant="contained"
          onClick={() => {
            window.open(anamneseURL, '_self');
            dynamicCustomEventTracking.send({
              dynamicEventName: `home_open_anamnese_mc`
            });
          }}
        >
          Responda às perguntas médicas
        </ButtonSmall>
      }
    />
  );
};

export const AwaitingAnamneselarge = ({ journey }: JourneyActionPayload) => {
  const anamneseURL = journey.haveToAnswerAnamnese;
  return (
    <JourneyAction
      icon={<CircleIcon border size="60px" icon={<WarningAmberIcon />} />}
      title="Responda às perguntas médicas"
      subtitle={`As perguntas te ajudam a aproveitar melhor o tempo da sua consulta. Leva só 5 minutos!`}
    >
      <ButtonSmall
        variant="contained"
        onClick={() => {
          window.open(anamneseURL, '_self');
          dynamicCustomEventTracking.send({
            dynamicEventName: `home_open_anamnese_mc`
          });
        }}
      >
        Responda às perguntas médicas
      </ButtonSmall>
    </JourneyAction>
  );
};
